import { createFileRoute } from '@tanstack/react-router'
import { FundamentalPage } from '../components/pages'
import { CatalogProvider } from '../content/catalog-context'
import { loadPageData } from '../content/page-data-fn'

export const Route = createFileRoute('/it/fondamenti/$fundamentalSlug')({
  loader: ({ params }) =>
    loadPageData({ data: { kind: 'fundamental', locale: 'it', params } }),
  head: ({ loaderData }) => loaderData?.head ?? {},
  component: RouteComponent,
})

function RouteComponent() {
  const { fundamentalSlug } = Route.useParams()
  return (
    <CatalogProvider snapshot={Route.useLoaderData().snapshot}>
      <FundamentalPage fundamentalSlug={fundamentalSlug} />
    </CatalogProvider>
  )
}
